import { useAllowedToSeeMembership } from 'src/api/Membership/useIsAllowedToSeeMembership'

/**
 * @deprecated use useAllowedToSeeMembership directly. Use this one means that loading & error are not handled
 */
export function useMembershipWhitelist() {
  const { isAllowedToSeeMembership } = useAllowedToSeeMembership()
  return isAllowedToSeeMembership?.isAllowed
}
